import { Box } from '@dtx-company/design-system/src/components/Box/Box'
import { HomePagePrismicText } from '../../components/HomePagePrismicText/HomePagePrismicText'
import { ImageField, RichTextField } from '@prismicio/client'
import { prismicImageLoader } from '../../utils/prismicImageLoader'
import Image from 'next/image'

export const CTA = ({
  img,
  line1,
  line2,
  trackLinkClick
}: {
  img: ImageField
  line1: RichTextField
  line2: RichTextField
  trackLinkClick: () => void
}): JSX.Element | null => {
  if (line1.length === 0 && line2.length === 0) return null
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '24px'
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: { xs: '64px', md: '80px' },
          height: { xs: '64px', md: '80px' }
        }}
      >
        <Image
          src={img.url || ''}
          alt={img.alt || 'broken image'}
          loader={prismicImageLoader}
          width={80}
          height={80}
        />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <HomePagePrismicText variant="body/regular" richTextField={line1} sx={{ margin: 0 }} />
        <HomePagePrismicText
          variant="body/regular"
          richTextField={line2}
          sx={{ marginBottom: 0, marginTop: '8px', fontWeight: '600' }}
          onClick={trackLinkClick}
        />
      </Box>
    </Box>
  )
}
